export default "__VITE_ASSET__121badfa__"